import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService, SmBaseService } from '../../core';
import { Observable } from 'rxjs';

@Injectable()
export class PricelistService extends SmBaseService {
    constructor(http: HttpService) {
        super(http, 'pricelist');
    }

    get(): Observable<PricelistModel[]> {
        return this._getAs<PricelistModel[]>();
    }

    getById(pricelistId: number): Observable<PricelistModel> {
        return this._getAs<PricelistModel>(pricelistId);
    }

    post(model: PricelistModel): Observable<Response> {
        return this._post('', model);
    }

    put(pricelistId: number, model: PricelistModel): Observable<Response> {
        return this._put(pricelistId, model);
    }

    delete(pricelistId: number): Observable<Response> {
        return this._delete(pricelistId);
    }
}

export const enum PricelistShipmentType {
    BankTransfer = 1, // Platba předem
    CashOnDelivery = 2 // Platba při převzetí
}

export interface PricelistModel {
    id: number;
    name: string;
    shipments?: PricelistShipmentModel[];
}

export interface PricelistShipmentModel {
    shipmentId: number;
    shipmentName: string;
    shipmentType: PricelistShipmentType;
    isEnabled: boolean;
    isReadonly: boolean;
    isFree?: boolean;
    priceForFirst?: number;
    priceForOther?: number;
    amountInPackage?: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/pricelist.service.ts